<template>
  <div
    v-show="isVisible"
    class="custom-cursor"
    :style="cursorStyle"
  >
    <!-- 회전하는 텍스트 + 선 -->
    <div class="cursor-ring">
      <svg class="ring-svg" viewBox="0 0 200 200">
        <defs>
          <path
            id="circlePath"
            d="M 100, 100 m -85, 0 a 85,85 0 1,1 170,0 a 85,85 0 1,1 -170,0"
          />
        </defs>
        <!-- 원형 호 (텍스트 끝~시작 연결) -->
        <circle
          cx="100"
          cy="100"
          r="85"
          class="cursor-arc"
        />
        <!-- 텍스트 -->
        <text class="cursor-text">
          <textPath href="#circlePath" startOffset="0%">
            TECHNO RAYONE CITY
          </textPath>
        </text>
      </svg>
    </div>

    <!-- 흰색 원 배경 -->
    <div class="cursor-inner-circle">
      <span class="scroll-text">SCROLL</span>
      <span class="down-text">DOWN</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCursor',
  data() {
    return {
      x: 0,
      y: 0,
      isMegaMenuOpen: false
    }
  },
  computed: {
    cursorStyle() {
      return {
        transform: `translate(${this.x}px, ${this.y}px)`
      }
    },
    isVisible() {
      // 홈페이지('/')에서만 보이고, 메가메뉴 열리면 숨김
      return this.$route.path === '/' && !this.isMegaMenuOpen
    }
  },
  mounted() {
    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('megamenu-toggle', this.handleMegaMenuToggle)
  },
  beforeUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('megamenu-toggle', this.handleMegaMenuToggle)
  },
  methods: {
    handleMouseMove(e) {
      this.x = e.clientX
      this.y = e.clientY
    },
    handleMegaMenuToggle(e) {
      this.isMegaMenuOpen = e.detail
    }
  }
}
</script>

<style scoped>
.custom-cursor {
  position: fixed;
  top: 0;
  left: 0;
  width: 180px;
  height: 180px;
  margin-left: -90px;
  margin-top: -90px;
  pointer-events: none;
  z-index: 9999;
  transition: transform 0.05s linear;
}

/* 회전하는 링 */
.cursor-ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: rotateCursor 10s linear infinite;
}

.ring-svg {
  width: 100%;
  height: 100%;
}

.cursor-text {
  font-family: var(--font-paperlogy);
  font-size: 14px;
  font-weight: 700;
  fill: var(--rayone-primary);
  letter-spacing: 4px;
  text-transform: uppercase;
}

.cursor-arc {
  fill: none;
  stroke: var(--rayone-primary);
  stroke-width: 2;
  stroke-linecap: round;
  /* H와 L 사이 빈틈 - 위쪽 */
  stroke-dasharray: 170 400;
  stroke-dashoffset: 500;
}

@keyframes rotateCursor {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 흰색 원 배경 */
.cursor-inner-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.scroll-text,
.down-text {
  font-family: var(--font-paperlogy);
  font-size: 10px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 2px;
}

</style>
